import React from 'react';
import { FaBalanceScale } from 'react-icons/fa';
import Card from '../common/Card';
import {
  BALANZA_MARCA_OPTIONS,
  BALANZA_MODO_OPTIONS,
  DEFAULT_HARDWARE_BALANZA
} from '../../utils/balanza/hardwareConfigDefaults';

const fieldClass = 'nexo-field mt-1';
const labelClass = 'block text-sm font-medium text-e0e3-muted';

/**
 * Configuración → Hardware → Balanza (UI v1).
 * Controles visibles; no conectados al parser ni al cajero en este sprint.
 */
export default function HardwareBalanzaSection({ value, onChange }) {
  const config = { ...DEFAULT_HARDWARE_BALANZA, ...(value || {}) };
  const personalizado = { ...DEFAULT_HARDWARE_BALANZA.personalizado, ...(config.personalizado || {}) };
  const esPersonalizado = config.marca === 'personalizado';

  const patch = (partial) => {
    onChange?.({ ...config, ...partial });
  };

  const patchPersonalizado = (field, fieldValue) => {
    patch({
      personalizado: {
        ...personalizado,
        [field]: fieldValue
      }
    });
  };

  return (
    <Card title="Hardware" icon={<FaBalanceScale />}>
      <div className="space-y-6">
        <p className="text-sm text-e0e3-muted">
          Dispositivos periféricos del punto de venta. La integración operativa se habilitará en versiones futuras.
        </p>

        <section aria-labelledby="hardware-balanza-heading" className="rounded-xl border border-white/10 bg-white/[0.03] p-4 sm:p-5">
          <h4 id="hardware-balanza-heading" className="text-base font-semibold text-e0e3-foreground mb-4">
            Balanza
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={labelClass} htmlFor="balanza-modo">Modo</label>
              <select
                id="balanza-modo"
                className={fieldClass}
                value={config.modo}
                onChange={(e) => patch({ modo: e.target.value })}
              >
                {BALANZA_MODO_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className={labelClass} htmlFor="balanza-marca">Marca</label>
              <select
                id="balanza-marca"
                className={fieldClass}
                value={config.marca}
                onChange={(e) => patch({ marca: e.target.value })}
              >
                {BALANZA_MARCA_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>

          {esPersonalizado && (
            <div className="mt-5 pt-4 border-t border-white/10">
              <p className="text-xs text-e0e3-muted mb-3">
                Formato personalizado (solo referencia visual; aún no afecta el escaneo en caja).
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {[
                  ['prefijo', 'Prefijo'],
                  ['longitud', 'Longitud'],
                  ['plu', 'PLU'],
                  ['separador', 'Separador'],
                  ['peso', 'Peso'],
                  ['digitoVerificador', 'Dígito verificador']
                ].map(([key, label]) => (
                  <div key={key}>
                    <label className="block text-xs font-medium text-e0e3-muted mb-1">{label}</label>
                    <input
                      type="text"
                      className="nexo-field text-sm"
                      value={personalizado[key] ?? ''}
                      onChange={(e) => patchPersonalizado(key, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>
    </Card>
  );
}
